import $ from "jquery";
import "slick-carousel";

$(".testimonials__slider-wrapper").slick({
  infinite: true,
  speed: 300,
  variableWidth: true,
  slidesToScroll: 1,
  slidesToShow: 4,
  arrows: true,
  dots: false,
  prevArrow: $(".prev-arrow"),
  nextArrow: $(".next-arrow"),
  responsive: [
    {
      breakpoint: 1368,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

